import { render, staticRenderFns } from "./CalculationDot.vue?vue&type=template&id=49444cca&scoped=true&"
import script from "./CalculationDot.vue?vue&type=script&lang=js&"
export * from "./CalculationDot.vue?vue&type=script&lang=js&"
import style0 from "./CalculationDot.vue?vue&type=style&index=0&id=49444cca&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49444cca",
  null
  
)

export default component.exports